import { render, staticRenderFns } from "./4mRiskRegister.vue?vue&type=template&id=4044be6a"
import script from "./4mRiskRegister.vue?vue&type=script&lang=js"
export * from "./4mRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4044be6a')) {
      api.createRecord('4044be6a', component.options)
    } else {
      api.reload('4044be6a', component.options)
    }
    module.hot.accept("./4mRiskRegister.vue?vue&type=template&id=4044be6a", function () {
      api.rerender('4044be6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/risk/4mRiskRegister.vue"
export default component.exports